import { Injectable } from '@angular/core';
import { Http,Response , Headers } from '@angular/http';
import { Config } from '../../../config/config';
import { VnptHttpService } from '../../services/vnpt-http.service';
import { Observable }     from 'rxjs/Observable';
import { NhomSanPham } from './nhom-san-pham';
@Injectable()
export class NhomSanPhamService {

    controller:string = 'DM_NhomSanPham';
    constructor(private http: Http) { }
    
    GetTree() {
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};
        return this.http.get(Config.apiUrl + this.controller+'/Tree', { headers: headers }).map(resp => resp.json());
    }
    
    GetList(keyword: string) {
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {};
        return this.http.get(Config.apiUrl + this.controller+'/GetList?keyword='+keyword, { headers: headers }).map(resp => resp.json());
               
    }

    GetListSort() {
        let headers = new Headers();       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.get(Config.apiUrl + this.controller+'/GetListSort', { headers: headers }).map(resp => resp.json());               
    }

    GetListFromPagination(paging:number,maxSize:number, keyword: string) {
        let headers = new Headers();
        let currentPage = paging - 1;
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetList?currentPage="+ currentPage+"&maxSize="+ maxSize + "&keyword=" + keyword, { headers: headers }).map(resp => resp.json());       
    }
    Save(item:NhomSanPham) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = item;
        return this.http.post(Config.apiUrl + this.controller+'/save', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    Delete(id) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            Id: id
        };
        return this.http.post(Config.apiUrl + this.controller+'/delete', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    KiemTra_CapCha(NSP) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = NSP;
        return this.http.post(Config.apiUrl + 'DM_NhomSanPham/KiemTraCapCha', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/sanpham/dm-nhom-san-pham/nhom-san-pham.service.ts